import $ from 'jquery';

const TAB_THRESHOLD = 6;
const DESKTOP_BREAKPOINT = 768;

$(() => {
    const $component = $('.plan-category');
    if (!$component.length) return;

    $component.each(function () {
        const $root   = $(this);
        const $tabs   = $root.find('.plan-category__tab');
        const $panels = $root.find('.plan-category__panel');
        const $tabsEl = $root.find('.plan-category__tabs');
        const $prev   = $root.find('.plan-category__tabs-arrow--prev');
        const $next   = $root.find('.plan-category__tabs-arrow--next');

        function isDesktop() {
            return $(window).width() >= DESKTOP_BREAKPOINT;
        }

        function getTabStep() {
            const firstTab = $tabs.get(0);
            if (!firstTab) return 0;
            const gap = parseInt(window.getComputedStyle($tabsEl.get(0)).gap) || 0;
            return firstTab.offsetWidth + gap;
        }

        function toggleArrowVisibility() {
            const show = isDesktop() && $tabs.length > TAB_THRESHOLD;
            if (show) {
                $prev.add($next).css('display', 'flex');
            } else {
                $prev.add($next).css('display', 'none');
            }
        }

        function getActiveIndex() {
            return parseInt($tabs.filter('.plan-category__tab--active').data('index')) || 0;
        }

        function updateArrowState() {
            const activeIndex = getActiveIndex();
            $prev.toggleClass('is-disabled', activeIndex <= 0);
            $next.toggleClass('is-disabled', activeIndex >= $tabs.length - 1);
        }

        function activateTab(index) {
            $tabs.removeClass('plan-category__tab--active').attr('aria-selected', 'false');
            $tabs.filter(`[data-index="${index}"]`).addClass('plan-category__tab--active').attr('aria-selected', 'true');

            $panels.removeClass('plan-category__panel--active');
            $panels.filter(`[data-index="${index}"]`).addClass('plan-category__panel--active');

            // Scroll active tab into view
            const tabsEl  = $tabsEl.get(0);
            const tabEl   = $tabs.filter(`[data-index="${index}"]`).get(0);
            const tabLeft    = tabEl.offsetLeft - tabsEl.offsetLeft;
            const tabRight   = tabLeft + tabEl.offsetWidth;
            const visibleLeft  = tabsEl.scrollLeft;
            const visibleRight = visibleLeft + tabsEl.clientWidth;

            if (tabLeft < visibleLeft) {
                tabsEl.scrollLeft = tabLeft - 16;
            } else if (tabRight > visibleRight) {
                tabsEl.scrollLeft = tabRight - tabsEl.clientWidth + 16;
            }

            updateArrowState();
        }

        $tabs.on('click', function () {
            activateTab(parseInt($(this).data('index')));
        });

        $prev.on('click', function () {
            if ($(this).hasClass('is-disabled')) return;
            const newIndex = getActiveIndex() - 1;
            if (newIndex >= 0) {
                activateTab(newIndex);
                $tabsEl.get(0).scrollBy({ left: -getTabStep(), behavior: 'smooth' });
            }
        });

        $next.on('click', function () {
            if ($(this).hasClass('is-disabled')) return;
            const newIndex = getActiveIndex() + 1;
            if (newIndex < $tabs.length) {
                activateTab(newIndex);
                $tabsEl.get(0).scrollBy({ left: getTabStep(), behavior: 'smooth' });
            }
        });

        $(window).on('resize', function () {
            toggleArrowVisibility();
            updateArrowState();
        });

        toggleArrowVisibility();
        updateArrowState();
    });
});
